module.exports = __webpack_public_path__ + "img/e4_img3.b79ea5f.jpg";